// const NGROK = 'http://localhost:40111';
const NGROK = 'https://api.anotherfloor.com';

export const configuration = {
    API_URL: `${NGROK}/api`,
    CACHED_STATICS_URL: `${NGROK}/`,
    CANONICAL: `${NGROK}`,
    BLOCKS_URL: `${NGROK}/api/public/block`,
    STATICS_URL: `${NGROK}/api/public/file/uploads/`,
    ASSETS_URL: `${NGROK}/api/public/file/asset/`,
    SOCKET_URL: `${NGROK}`,
    TITLE_PREFIX: 'Another Floor - ',
    INDEX_ENDPOINT: 'index',
    GOOGLE_MAP_API_KEY: 'AIzaSyCAIOCHVXSr1I0c5M8_3n4P-beP4XAPWa0',
    INSTAGRAM_URL: `https://api.instagram.com/v1/users/self/media/recent/?access_token=`,
    INSTAGRAM_CLIENT_ID: '1b2f092904c74f09aed0cda64de9f9e6',
    INSTAGRAM_ACCESS_TOKEN: '7223450222.72766eb.f8509cfd1ec6420b993c89143c1fe6a1',
    DEV_MODE: false,
}
